/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../common/app-shared.module';
import {AdminResourcePagesModule} from '../common/controller/admin-resource-pages.module';
import {SearchSelectComponent} from '../common/controller/search-select.component';
import {AdnTeamSelectorComponent} from '../common/controller/team-selector.component';
import {StatsTablesModule} from '../common/controller/stats-tables.module';
import {AdnSelectComponent} from '../common/directives/adn-select/adn-select.component';
import {ChartsModule} from '../common/directives/charts.module';
import {AdnCountrySelectComponent} from '../common/directives/country-select/adn-country-select.component';
import {ExplorationComponent} from '../common/directives/exploration.component';
import {ExplorationTableComponent} from '../common/directives/exploration-table.component';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {AdminRichTextFieldComponent} from '../common/directives/notes/admin-rich-text-field.component';
import {NotesComponent} from '../common/directives/notes/notes.component';
import {ObjectNotesButtonComponent} from '../common/directives/notes/object-notes-button.component';
import {AdStatusLabelComponent} from '../ad-unit/ad-status-component';
import {AdvertiserStatusLabelComponent} from '../advertiser/advertiser-status-component';
import {CreativePreviewModule} from '../creative/creative-preview.module';
import {ReportWidgetsModule} from '../report/report-widgets.module';
import {TargetingModule} from '../targeting/targeting.module';
import {SiteAnalysisPageComponent} from './site-analysis-page.component';
import {SiteApprovalPreviewModalComponent} from './site-approval-preview-modal.component';
import {SiteBulkActionModalComponent} from './site-bulk-action-modal.component';
import {SiteCopyModalComponent} from './site-copy-modal.component';
import {SiteCreativeSummaryComponent} from './site-creative-summary.component';
import {SiteEditPageComponent} from './site-edit-page.component';
import {SiteItemPageComponent} from './site-item-page.component';
import {SiteListPageComponent} from './site-list-page.component';

const SITE_COMPONENTS = [
  SiteAnalysisPageComponent,
  SiteApprovalPreviewModalComponent,
  SiteBulkActionModalComponent,
  SiteCopyModalComponent,
  SiteCreativeSummaryComponent,
  SiteEditPageComponent,
  SiteItemPageComponent,
  SiteListPageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminResourcePagesModule,
    AdnSelectComponent,
    ChartsModule,
    AdnCountrySelectComponent,
    CreativePreviewModule,
    ExplorationComponent,
    ExplorationTableComponent,
    FormControlsModule,
    AdminRichTextFieldComponent,
    NotesComponent,
    ObjectNotesButtonComponent,
    ReportWidgetsModule,
    AdStatusLabelComponent,
    AdvertiserStatusLabelComponent,
    SearchSelectComponent,
    AdnTeamSelectorComponent,
    StatsTablesModule,
    TargetingModule
  ],
  declarations: SITE_COMPONENTS,
  exports: SITE_COMPONENTS
})
export class SiteModule {
}
